<template>
    <div class="main-container">
        <div class="login-wrapper">
          <!-- Logo (above card) -->
          <img :src="logo" alt="Wingio Logo" class="mb-3" height="80">

          <!-- Card -->
          <div class="login-card text-center">
            <div class="alert alert-danger small" role="alert" v-if="error">
              We couldn’t find this email in our system. If you haven't purchased a device yet, 
              <a href="https://www.mywingio.com/">click here to buy one from our website. </a>
            </div>
            <h6 class="mb-1 text-left pl-4 small"><b>Welcome back!</b></h6>

            <form class="p-4">

              <div class="form-group text-left mb-1">
                <label for="password" class="form-label">Password</label>
                <div class="password-input-wrapper">
                  <input
                    :type="showPassword ? 'text' : 'password'"
                    v-model="password"
                    id="password"
                    class="form-control"
                    placeholder="Password"
                    required
                  />
                  <span class="toggle-eye" @click="showPassword = !showPassword">
                    <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                  </span>
                </div>
              </div>

                <div class="form-group text-left mb-1">
                <label for="password" class="form-label">Confirm Password</label>
                <div class="password-input-wrapper">
                  <input
                    :type="showPassword ? 'text' : 'password'"
                    v-model="confirmPassword"
                    id="password"
                    class="form-control"
                    placeholder="Confirm Password"
                    required
                  />
                </div>
              </div>
              <button type="submit" class="btn btn-primary w-100 mt-2" :disabled="isDisabled" @click="resetPassword()">
                Update Password <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
              </button>

            </form>
          </div>

          <p class="recaptcha-text">
            <a href="https://www.mywingio.com/privacy">Privacy Policy</a> and
            <a href="https://www.mywingio.com/terms-conditions">Terms of Service</a> apply.
          </p>
        </div>
    </div>
</template>

<script>
import UserService from "../services/UserService";
export default {
  name: 'Set Password',
  props: {
    logo: {
        type: String,
        default: "/images/lya-logo.png",
    },
  },
  data() {
    return {
      isDisabled: false,
      confirmPassword: null,
      password: null,
      userDetail: null,
      showPassword: false,
      error: this.$route.query.error,
      
    };
  },
  methods: {
    resetPassword() {
        this.isDisabled = true;
        var data = {
            password: this.password,
            confirm_password: this.confirmPassword,
            iv: this.$route.query.iv,
            encrypted_data: this.$route.query.encryptedData,
            isWingioUser: true,
        };
        UserService.resetPassword(data)
            .then((response) => {
                this.isDisabled = false;
                this.$toast.success(response.data.respones_msg);
                if (response.data.data) {
                  localStorage.setItem('token', response.data.data);
                  document.location = "/kids-device";
                } else {
                  this.$router.push('/login');
                }
                
            }).catch((e) => {
                this.isDisabled = false;
                this.$toast.error(e.response.data.respones_msg);
            });
    },
    async verifyEmail(iv, encryptedData) {
      this.isDisabled = true;
      let data = {
        iv: iv,
        encryptedData: encryptedData,
        isWingioUser: true,
      };
      await UserService.verifyEmail(data)
        .then((response) => {
            this.isDisabled = false;
          this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async isUserLogin() {
      await UserService.isUserLogin()
        .then((response) => {
          document.location = "/kids-device";
        }).catch((e) => {
        });
    },
    togglePasswordDisplay(showPassword) {
      if (showPassword == true) {
        $('#password-input').attr('type', 'text');
      } else {
        $('#password-input').attr('type', 'password');
      }
      this.showPassword = showPassword;
    },
    redirectToGoogleLoginPage() {
      //window.open(process.env.VUE_APP_API_URL + "users/auth/google", "_blank");
      window.location.href = process.env.VUE_APP_API_URL + "users/auth/google"
    },


  },
  beforeMount() {
    if (this.$route.query.iv && this.$route.query.encryptedData) {
      this.verifyEmail(this.$route.query.iv,this.$route.query.encryptedData);
    }
    if (this.$route.query.token) {
      localStorage.setItem('token', this.$route.query.token);
      document.location = "/kids-device";
    }
    this.isUserLogin();
  },
}
</script>
<style scoped>
.login-wrapper {
  max-width: 400px;
  text-align: center;
}
.login-card {
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  background: #fff;
}
.recaptcha-text {
  font-size: 11px;
  color: #6c757d;
  margin-top: 1rem;
}
.password-input-wrapper {
  position: relative;
}

.password-input-wrapper input {
  padding-right: 2.5rem; /* space for the eye icon */
}

.toggle-eye {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #6c757d;
}

</style>